
// this file is automatically generated by git.version.ts script
export const GIT_VERSION_INFO = {
  version: '0.0.0',
  revision: '83933a7aff60c7e40a89ad5e3da62231e7cc5f56',
  branch: 'develop'
};